const fs = require('fs');
const fse = require('fs-extra');

/**
 * Error resolution states
 */
export enum ResolveState {
    Resolved = 'RESOLVED',
    Unresolved = 'UNRESOLVED'
}

export class Common {
    public static readonly cliRootPath = __dirname.substring(0, __dirname.length - 3);
    public static readonly moduleTemplatePath = __dirname.substring(0, __dirname.length - 11) + 'module-template\\';

    private static _rootPath: string;

    /**
     * Gets the root path for the current repository
     * @returns {string} Root path for the current repository
     */
    public static get rootPath() {
        return Common._rootPath;
    }

    /**
     * Sets the root path for the current repository
     * @param {string} path Root path for the current repository
     */
    public static set rootPath(path) {
        Common._rootPath = path;
    }

    /**
     * Retrieves content of given file
     * @param {string} filePath Target file path
     * @returns {string | null} String representation of file content or null if file was not found
     */
    public static readFileData(filePath) {
        if (!fs.statSync(filePath).isDirectory()) {
            if (!fse.existsSync(filePath)) {
                return null;
            }

            return fse.readFileSync(filePath, 'utf8');
        }

        return null;
    }

    /**
     * Writes to the content of given file
     * @param {string} filePath Target file path
     * @returns {boolean} indicates whether the file was written successfully.
     */
    public static writeFileData(filePath, newContent): boolean {
        if (!fs.statSync(filePath).isDirectory()) {
            if (!fse.existsSync(filePath)) {
                return false;
            }

            fse.writeFileSync(filePath, newContent, 'utf8');

            return true;
        }

        return false;
    }

    /**
     * Creates the file with content.
     * @param {string} filePath Target file path
     * @param {string} newContent Content to write to the file
     */
    public static async writeFile(filePath, newContent): Promise<void> {
        await fs.writeFile(filePath, newContent, (err) => {
            if (err) {
                console.error('Error creating file:', err);
                return;
            }
        });
    }

    /**
     * Retrieves content of given JSON file and parses into an object
     * @param {string} filePath Target file path
     * @returns {any | null} Parsed JSON object or null if file was not found
     */
    public static readFileJSON(filePath) {
        if (!fs.statSync(filePath).isDirectory()) {
            if (!fse.existsSync(filePath)) {
                return null;
            }

            return fse.readJSONSync(filePath);
        }

        return null;
    }

    /**
     * Replaces part of target string with a new string using given regex
     * @param {string} originalString Target string
     * @param {RegExp} regexToReplace Regex to apply to target string
     * @param {string} newString String that will replace regex matches
     * @returns {string} New string created from replacing regex matches or original string if no matches were found
     */
    public static replaceInString(originalString, regexToReplace, newString) {
        return originalString.replace(regexToReplace, newString);
    }
}
